import { useState } from "react";
import { Swiper as SwiperType } from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Badges, H5, Image, P } from "../../../../AbstractElements";
import { carouselTimelineData } from "../../../../Data/BonusUi/Timeline";
import { dynamicImage } from "../../../../Utils";

export default function CarouselTimeline() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="cd-timeline-block">
      <div className="cd-timeline-img cd-picture bg-success">
        <i className="icon-image" />
      </div>
      <div className="cd-timeline-content">
        <div className="timeline-wrapper">
          <Badges color="info">{"Designer"}</Badges>
        </div>
        <H5 className="f-w-600 m-0">{"Research about most recent design trends."}</H5>
        <P className="mb-0">{"Spend some time looking up current design trend."}</P>
        <Swiper navigation modules={[Navigation, Pagination]} pagination={{ clickable: true }} slidesPerView={1} onSlideChange={(swiper: SwiperType) => setActiveIndex(swiper.realIndex)} className="carousel-inner">
          {carouselTimelineData.map((item, index) => (
            <SwiperSlide key={index}>
              <div className={`carousel-item ${index === activeIndex ? "active" : ""}`}>
                <Image src={dynamicImage(`banner/${item.image}`)} alt="drawing-room" className="d-block w-100" />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <span className="cd-date">April 23 2024</span>
      </div>
    </div>
  );
}
